export enum EProcessType {
  REGULAR = 1,
  AGENTS = 2,
  AFFILIATE = 3
}
